export default "__VITE_ASSET__DQpzJdb9__"